import React from 'react';

import clsx from 'classnames';

export function Layout({
  className,
  children,
  background,
  grid,
  gap,
  display,
  padding,
  variant,
  ...props
}) {
  const layoutClass = clsx(
    {
      'cdl-layout': true,
      'cdl-layout--form': variant === 'form',

      'cdl-layout--padding-none': padding === 'none',
      'cdl-layout--padding-small': padding === 'small',
      'cdl-layout--padding-medium': padding === 'medium',
      'cdl-layout--padding-large': padding === 'large',

      'cdl-layout--gap-none': gap === 'none',
      'cdl-layout--gap-small': gap === 'small',
      'cdl-layout--gap-medium': gap === 'medium',
      'cdl-layout--gap-large': gap === 'large',

      'cdl-layout--flex': display === 'flex',
      'cdl-layout--flex-column': display === 'flex-column',
      'cdl-layout--block': display === 'block',

      'cdl-layout--grid cdl-layout--grid-1-1': grid === '1-1',
      'cdl-layout--grid cdl-layout--grid-1-2': grid === '1-2',
      'cdl-layout--grid cdl-layout--grid-2-1': grid === '2-1',
      'cdl-layout--grid cdl-layout--grid-1-3': grid === '1-3',
      'cdl-layout--grid cdl-layout--grid-3-1': grid === '3-1',
      'cdl-layout--grid cdl-layout--grid-1-1-1': grid === '1-1-1',

      'cdl-layout--background-primary': background === 'background-primary',
      'cdl-layout--background-secondary': background === 'background-secondary',
      'cdl-layout--background-tertiary': background === 'background-tertiary',
      'cdl-layout--background-inverse-primary':
        background === 'background-inverse-primary',
      'cdl-layout--background-inverse-secondary':
        background === 'background-inverse-secondary',
    },
    className
  );
  return (
    <div className={layoutClass} {...props}>
      {children}
    </div>
  );
}
